import React, {Component, PropTypes} from 'react';
import { Map } from 'immutable';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as authActions from '../../auth/auth.actions';
import * as changeEmailActions from './change-email.actions';
import { toastr } from 'react-redux-toastr';
import { SsgFormComponent, ssgFormActions, Widget, CustomIcon, CustomIconSet } from '@social-solutions/ssg-forms';
import { formDefinition } from '@social-solutions/ssg-forms-processing';
import formStyle from '../account-widget.style';
import "./change-email.scss"


const formComponentId = "change-email-form-response";

const passwordElement = {
  id: "change-email-current-password",
  type: formDefinition.elementTypes.specialText,
  label: "Re-Enter your Current Password",
  ariaLabel: "Re-Enter your Current Password",
  isPassword: true,
  textType: formDefinition.specialTextTypes.ANY,
  isRequired: true,
};

const emailElement = {
  id: 'email',
  type: formDefinition.elementTypes.email,
  label: "Email",
  ariaLabel: "Email",
  isRequired: true,
};

export class ChangeEmailComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      updating: false,
    }
  }

  /**
   * Handles the save button being clicked
   * @param {*} state the current form state when save is clicked
   */
  handleFormSubmit(state) {
    const { auth, changeEmailActions, ssgFormActions } = this.props;
    const { updateEmail } = changeEmailActions;
    const { resetForm, processForm } = ssgFormActions;
    const { user } = auth.currentSession;
    const passwordValue = formDefinition.getValue(state, passwordElement.id);
    const newEmailValue = formDefinition.getValue(state, emailElement.id);

    if(!state.validationResult.passedValidation) {
      const firstError = state.validationResult.errors.first();
      const errorElement = firstError && document.getElementById(firstError.sourceId);
      errorElement && errorElement.focus();
      return;
    }

    updateEmail(user.id, passwordValue, newEmailValue)
      .then(() => {
        toastr.success('Success', 'Your email has been changed.');
        resetForm(formComponentId);
        processForm(formComponentId);
        this.setState({updating: false});
      })
      .catch( err => {
        toastr.error(err.errorCode, err.errorMessage);
        throw(err);
      });
  }

  /**
   * Handles the cancel button being clicked.
   * Changes back to read only mode and clears any changes
   * @param {*} e the current form state when cancel is clicked
   */
  handleCancel(e) {
    const { ssgFormActions } = this.props;
    const { resetForm, processForm } = ssgFormActions;
    resetForm(formComponentId);
    processForm(formComponentId);
    this.setState({updating: false});
  }

  /**
   * Handles the update button being clicked, enters edit mode
   */
  handleUpdate() {
    this.setState({updating: true});
  }

  /** gets the default value for the email */
  getDefaultValue() {
    const { currentSession } = this.props.auth;
    const user = currentSession && currentSession.user;
    var emailDefault = user && user.email;
    return Map({
      [emailElement.id]: emailDefault,
    });
  }

  /** renders the form for edit mode */
  renderEditForm() {
    const { changeEmail } = this.props;
    const { updateState } = changeEmail;
    const { isFetching } = updateState || {};

    var saveButton = {
      id: "save-button",
      type: "submit",
      display: "Save",
      ariaLabel: "Save",
      buttonType: "primary",
      functionType: "submit",
      spinnerOn: isFetching,
      spinnerDisplay: "Saving",
      onClick: (state) => this.handleFormSubmit(state),
    };

    var cancelButton = {
      id: "cancel-button",
      type: "button",
      display: "Cancel",
      ariaLabel: "Cancel",
      buttonType: "default",
      functionType: "none",
      spinnerOn: false,
      disabled: isFetching,
      onClick: (state) => this.handleCancel(state),
    }

    const formProps = {
      id: formComponentId,
      form: {
        id: formComponentId,
        name: null,
        elements: [ emailElement, passwordElement ]
      },
      disableValidationResultList: true,
      elementStyles: formStyle,
      buttonLayout: [ cancelButton, saveButton ],
      defaultValue: this.getDefaultValue(),
      css: {
        title: "ssg-forms-text large account-widget-title",
        actions: "ssg-forms-plain-actions",
      }
    };

    return <SsgFormComponent {...formProps} />;
  }

  /** renders the form for readonly mode */
  renderReadOnlyForm() {

    var updateButton = {
      id: "update-email-button",
      type: "button",
      display: "Update",
      ariaLabel: "Update",
      buttonType: "secondary",
      functionType: "none",
      onClick: () => this.handleUpdate(),
    };

    const formProps = {
      id: formComponentId,
      readOnly: true,
      form: {
        id: formComponentId,
        name: null,
        elements: [{
          ...emailElement,
          isRequired: false,
        }]
      },
      disableValidationResultList: true,
      elementStyles: formStyle,
      buttonLayout: [ updateButton ],
      initialValues: this.getDefaultValue(),
      css: {
        actions: "ssg-forms-plain-actions",
      }
    };

    return <SsgFormComponent {...formProps} />;
  }

  render() {
    const { updating } = this.state;

    var participantIcon = (
      <CustomIcon
        iconChoice={CustomIconSet.ic_portal_participants_36x36_2x}
        css={{
          ssgCustomIcon: 'participants-type-icon'
        }}/>
    );

    return (
      <Widget anchorDisplay={participantIcon} css={{widgetDisplay: 'ssg-forms-widget account-widget'}}>
        {updating ? this.renderEditForm() : this.renderReadOnlyForm()}
      </Widget>
    );
  }
}

ChangeEmailComponent.propTypes = {
  authActions: PropTypes.any.isRequired,
  changeEmail: PropTypes.any.isRequired,
  changeEmailActions: PropTypes.any.isRequired
};

const mapStateToProps = ({ changeEmail, auth, ssgForms }) => {
  return {
    auth,
    changeEmail,
    ssgForms,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    authActions: bindActionCreators(authActions, dispatch),
    changeEmailActions: bindActionCreators(changeEmailActions, dispatch),
    ssgFormActions: bindActionCreators(ssgFormActions, dispatch),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ChangeEmailComponent);



// WEBPACK FOOTER //
// src/acct/email/change-email.component.js